import tryggboIcon from '@/assets/tryggbo-icon.svg';

interface TryggboIconProps {
  className?: string;
  size?: number;
}

export function TryggboIcon({ className, size = 32 }: TryggboIconProps) {
  return (
    <img
      src={tryggboIcon}
      alt="Tryggbo"
      className={className}
      style={{
        height: `${size}px`,
        width: 'auto',
        objectFit: 'contain',
      }}
      draggable={false}
    />
  );
}
